import { GetSelfServeSponsorResponse, getSelfServeSponsorRequest } from 'api';
import { UseQueryOptions, useQuery } from 'react-query';
import { adCampaignsQueries } from './queryKeys';

type QueryKey = ReturnType<typeof adCampaignsQueries.selfServeSponsorRequest>;

function useGetSelfServeSponsorRequest<TData = GetSelfServeSponsorResponse>(
  selfServeSponsorRequestId: number | null,
  opts?: Omit<
    UseQueryOptions<GetSelfServeSponsorResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery(
    adCampaignsQueries.selfServeSponsorRequest(selfServeSponsorRequestId),
    () =>
      getSelfServeSponsorRequest({
        selfServeSponsorRequestId: selfServeSponsorRequestId as number,
      }),
    { enabled: !!selfServeSponsorRequestId, ...opts },
  );
}

export const useSelfServeSponsorRequestDraft = (
  selfServeSponsorRequestId: number | null,
) => useGetSelfServeSponsorRequest(selfServeSponsorRequestId);
